jQuery(document).ready(function ($) {
    const url = window.location;
    if (window.innerWidth < 768) {
        $('#toggleMenu').click(function () {
            $('#top-navigation').css('height', 'auto');
        });
        $('#toggleSearch').click(function () {
            $('#top-navigation').css('height', 'auto');
        });
    } else {
        $(".current-menu-item").parent().parent().parent().parent().addClass('hoveri')
    }
    window.addEventListener("resize", function(){
        if (window.innerWidth > 1025) {
            $('.menu-item-has-children ').each(function( index ) {
              $(this).find('img').css('display','none')
            })
        }
    });
    if (window.innerWidth < 1025) {
        if (window.innerWidth < 1025) {
            $('.menu-item-has-children ').each(function( index ) {
                $(this).append("<img src='"+url.protocol+"//"+url.hostname+"/wp-content/themes/oddsnet.com-child/assets/images/bottom-menu-arrow.png' />")

            })
        }
        $('.menu-item-has-children').click(function () {
            $('.menu-item-has-children').children('ul').each(function( index ) {
                $(this).css('display', 'none');
            })
            if($(this).parent('li.menu-item-has-children').parent('ul.sub-menu')){
                $(this).parent('li.menu-item-has-children').parent('ul.sub-menu').css('display', 'block')
            }
            let main_menu = $(this).closest('#top-navigation');
            if ($(this).closest('.menu-item-has-children').find('.sub-menu')[0].classList.contains('show')) {
                main_menu.css('height', 'auto');
                $(this).closest('.menu-item-has-children').find('.sub-menu')[0].classList.remove('show');;
                $(this).closest('.menu-item-has-children').find('.sub-menu')[0].style.display="none";
            } else {
                if($(this).closest('.menu-item-has-children').parent('ul').children('li.menu-item-has-children').children('ul')){
                    $(this).closest('.menu-item-has-children').parent('ul').children('li.menu-item-has-children').children('ul').each(function() {
                        $(this).removeClass('show')
                    });
                }
                $(this).closest('.menu-item-has-children').find('.sub-menu')[0].classList.add('show');
                $(this).closest('.menu-item-has-children').find('.sub-menu')[0].style.display="block";
                // $(this).attr('aria-expanded', 'true');
                setTimeout(function () {
                    if (window.innerHeight < main_menu.outerHeight()) {
                        main_menu.css('height', '100%');
                    }
                }, 200)
            }
        });
    }
});

jQuery(document).ready(function() {
    // Show the third-tier menu on hover
    jQuery('.menu-item-has-children .menu-item-has-children').hover(
        function() {
            // Calculate the distance from the menu item to the top of the page
            var distanceToTop = jQuery(this).offset().top - jQuery(document).scrollTop();
            // Apply the calculated distance to the top property of the third-tier submenu
            jQuery(this).find('.sub-menu').css('top', distanceToTop);
            
        },
    );
});

jQuery(document).ready(function() {
    jQuery('.menu-item-has-children .menu-item-has-children').hover(
        function() {
            // Generate a unique identifier for the style tag based on the current timestamp
            var uniqueId = 'hide-scrollbar-' + new Date().getTime();
            var styleContent = '<style id="' + uniqueId + '">';
            styleContent += '.menu-item-has-children:hover > .sub-menu::-webkit-scrollbar { display: none; }';
            styleContent += '</style>';
            
            // Set a data attribute on the hovered element to keep track of the unique style tag id
            jQuery(this).closest('.menu-item-has-children').data('styleTagId', uniqueId).append(styleContent);
        }, 
        function() {
            // Retrieve the unique style tag id from the data attribute
            var styleTagId = jQuery(this).closest('.menu-item-has-children').data('styleTagId');
            // Remove the dynamically added style tag to revert the scrollbar
            jQuery('#' + styleTagId).remove();
        }
    );
});


